import PageScroller from './page-scroller';
import UrlUpdater from './url-updater';

export default class Router {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {
        $body: $('body'),
        bodyClasses: '',
        pageScroller: new PageScroller(),
        urlUpdater: new UrlUpdater()
      };

      // Enable/disable single-page mode in theme settings

      const enableSinglePage = this.state.$body.data('single-page');

      if (enableSinglePage) {
        console.log('SINGLE PAGE MODE');

        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }

        this.setupEventListeners();
      }
    }
  }

  //===========================================================================
  // Updates before the page change
  //===========================================================================

  beforePageChange(href) {
    const $body = this.state.$body;
    const $cartDrawerContent = $('.js-cart-drawer-content');
    let bodyClasses = '';

    // Sets the css classes for the <body>

    $body.removeClass('cart-drawer-active');
    $body.removeClass('account-drawer-active');
    $body.removeClass('mobile-nav-active');
    $body.removeClass('scroll-slideshow-active');
    $body.removeClass('hide-widgets');
    $body.addClass('disable-nav');

    if ($body[0]) {
      $body[0].classList.forEach((cl) => {
        if (cl && !cl.includes('template-') && !cl.includes('scroll')) {
          bodyClasses += ' ';
          bodyClasses += cl;
        }
      });
    }

    this.state.bodyClasses = bodyClasses;

    // Disables the cart drawer if on the /cart page

    if (href && href.includes('/cart')) {
      $cartDrawerContent.empty().removeClass('js-cart-content');
    } else {
      $cartDrawerContent.addClass('js-cart-content');
    }
  }

  //===========================================================================
  // Checks if a history change can be performed on the link
  //===========================================================================

  checkIfValidLink($target) {
    const href = $target[0] ? $target[0].getAttribute('href') : '';
    const forbiddenClasses = {
      'js-ajax-load-link': true,
      'js-cart-toggle': true,
      'js-account-toggle': true,
      'js-add-to-cart-duo': true,
      'js-add-to-cart': true,
      'js-add-to-cart-alias': true,
      'js-add-to-cart-bundle': true,
      'js-add-to-cart-variant': true,
      'js-switch-link': true,
      'js-accordion-header': true,
      'js-remove-cart-item': true,
      'js-disable-ajax': true
    };

    let isValid = true;


    if (!href
      || href[0] === '#'
      || href.substring(0, 4) === 'http'
      || href.includes('/checkout')
      || href.includes('/account')
      || href.includes('/tools/recurring'))
    { isValid = false; }

    if ($target[0]) {
      $target[0].classList.forEach((cl) => {
        if (cl && forbiddenClasses[cl]) {
          isValid = false;
        }
      });
    }

    return isValid;
  }

  //===========================================================================
  // Change the page from browser back/forward
  //===========================================================================

  changePageFromPopstate() {
    const href = document.location.href;
    this.changePage(href, false);
  }

  //===========================================================================
  // Change the page from link click
  //===========================================================================

  changePageFromLink(e) {
    const $target = $(e.currentTarget);
    const href = $target[0] ? $target[0].getAttribute('href') : '';
    const allowHistoryChange = this.checkIfValidLink($target);

    if (allowHistoryChange) {
      e.preventDefault();
      this.changePage(href, true);
    }
  }

  //===========================================================================
  // Change the page from form submit (Ex: Search form)
  //===========================================================================

  changePageFromForm(e) {
    const $target  = $(e.currentTarget);
    const $input   = $target.find('input');
    const action   = $target[0] ? $target[0].action : '';
    const search   = $target.serialize();
    const href     = action + '?' + search;

    if (action && search) {
      e.preventDefault();
      $target[0].reset();
      $input.blur();
      this.changePage(href, true);
    }
  }

  //===========================================================================
  // Change the page
  //===========================================================================

  changePage(href, updateHistory) {
    const currentPageIsCart = document.location.href && document.location.href.includes('/cart');
    const self = this;

    this.beforePageChange(href);

    $.ajax({
      url: href,
      type: 'GET',
      dataType: 'html',
      success: function (data) {
        if (data) {
          if (updateHistory) {
            self.state.urlUpdater.historyChange(href);
          }

          self.afterPageChange(data);

          if (currentPageIsCart) {
            $(document).trigger('cartRefresh');
          }
        } else {
          document.location.href = href;
        }
      }
    });
  }

  //===========================================================================
  // Set up the new page after template retrieval
  //===========================================================================

  afterPageChange(data) {
    const $templateBody = $(`<div>${ data }</div>`);
    const $siteMain = $('main');
    const template = $templateBody.find('main').html();
    const templateClass = $templateBody.find('.js-template-class').val() || '';
    const bodyClasses = `${ templateClass } ${ this.state.bodyClasses }`;
    const pageTitle = $templateBody.find('.js-page-title').val() || 'Odacité';
    const hash = window.location.hash;

    if (template) {
      $siteMain.empty();
      window.scrollTo(0,0);
      $siteMain.html(template);
      document.title = pageTitle;

      if (hash) {
        this.state.pageScroller.scrollToSection(hash, true);
      }

      if (bodyClasses) {
        this.state.$body[0].classList = bodyClasses;
      }

      setTimeout(() => {
        this.state.$body.removeClass('disable-nav');
      }, 1000);

      console.log('HISTORY CHANGE');
      $(document).trigger('historyChange');
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', 'a', this.changePageFromLink.bind(this));
    $(document).on('submit', '.js-router-form', this.changePageFromForm.bind(this));
    $(window).on('popstate', this.changePageFromPopstate.bind(this));
  }
}
